import { callMultiple } from './call-multiple.js';

export function mergeCalls(
  ...props: Record<string, Maybe<AnyFunction>>[]
): Record<string, AnyFunction> {
  return Object.entries(
    props.reduce<Record<string, Maybe<AnyFunction>[]>>((record, obj) => {
      Object.entries(obj).forEach(([key, value]) => {
        if (!(key in record)) {
          record[key] = [];
        }

        record[key].push(value);
      });

      return record;
    }, {})
  ).reduce<Record<string, AnyFunction>>((record, [key, value]) => {
    record[key] = callMultiple(...value);

    return record;
  }, {});
}
